import script from "./SyllableDragGame.vue?vue&type=script&setup=true&lang=js"
export * from "./SyllableDragGame.vue?vue&type=script&setup=true&lang=js"

import "./SyllableDragGame.vue?vue&type=style&index=0&id=52f2cfda&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f2cfda"]])

export default __exports__